// extracted by mini-css-extract-plugin
export default {"container":"container_mYkD0","top":"top_c85Xb","avatar":"avatar_Vb4aV","infoContainer":"infoContainer_H_oYu","progressWrapper":"progressWrapper_yivv5"};